<a
  class="py-2.5 block font-accent text-white text-sm"
  [link]="link"
  [target]="openInNewTab ? '_blank' : '_self'"
  >{{ name }}</a
>
